<ul *ngIf="shouldShowErrors()">
    <li *ngFor="let error of listOfErrors()"><small class="ms-TextField-errorMessage">{{error}}</small></li>
</ul>